import { Component, EventEmitter, Input, Output } from "@angular/core";
import { getErrorMessage } from "../../helpers/function";
import { UploadButtonService } from "./upload-btn.service";
import { MessageService } from "primeng/api";

@Component({
  selector: "upload-btn",
  templateUrl: "./upload-btn.component.html"
})
export class UploadButtonComponent {
  loading = false;
  showInput = true;

  @Input()
  btnLabel = "Cargar archivo";

  @Input()
  btnClass = "btn-primary";

  @Input()
  showBtn = true;

  @Input()
  disabled = false;

  @Input()
  btnStyle = {};

  @Input()
  acceptFiles = "";

  @Input()
  url = "";

  @Input()
  maxSizeMB = 5;

  @Input()
  maxFiles = 1;

  @Input()
  icon = "fa fa-cloud-upload";

  @Input()
  showIcon = true;

  @Input()
  offLineMode = false;

  @Output()
  onSuccess = new EventEmitter<any>();

  @Output()
  onData = new EventEmitter<any>();

  @Output()
  onError = new EventEmitter<any>();

  @Output()
  onSaving = new EventEmitter<any>();

  constructor(
    public service: UploadButtonService,
    public toastr: MessageService
  ) {}

  onChangeFile(event: any) {
    const files = event.target.files;

    if (this._isValidFiles(files)) {
      if (this.offLineMode) {
        this.onData.emit(files);
        this.resetInput();
        return;
      }

      if (!this.url || this.url.trim().length == 0) {
        this.throwError("Debe configurar una URL valida");
        this.resetInput();
        return;
      }

      this.saveFiles(files);
    }
  }

  private _isValidFileSize(file: File) {
    const fileSizeinMB = file.size / (1024 * 1000);
    const size = Math.round(fileSizeinMB * 100) / 100; // convert upto 2 decimal place

    if (size > this.maxSizeMB) {
      this.throwError(
        `El archivo supera el limite de tamaÃ±o permitido. (${this.maxSizeMB} MB)`
      );

      return false;
    }
    return true;
  }

  clickButton() {
    document.getElementById("upload-btn-ar").click();
  }

  private _isValidFileExtension(files: File[]) {
    const extensions = this.acceptFiles.split(",").map(function(x) {
      return x.toLocaleUpperCase().trim();
    });

    let flag = true;

    for (let i = 0; i < files.length; i++) {
      const ext =
        files[i].name
          .toUpperCase()
          .split(".")
          .pop() || files[i].name;
      const exists = extensions.includes(`.${ext}`);

      if (!exists) {
        this.throwError(`Este tipo de archivo no esta soportado.`);

        return false;
      }

      flag = this._isValidFileSize(files[i]);
    }

    return flag;
  }

  private _isValidFiles(files: File[]) {
    if (files.length == 0) return false;

    if (files.length > this.maxFiles) {
      this.throwError(
        `La cantidad de archivos permitidos para subir es de ${this.maxFiles}.`
      );

      return false;
    }

    return this._isValidFileExtension(files);
  }

  saveFiles(files: File[]) {
    this.loading = true;
    this.onSaving.emit(this.loading);

    if (files.length > 0 && this._isValidFiles(files)) {
      const formData: FormData = new FormData();

      for (let j = 0; j < files.length; j++)
        formData.append("file[]", files[j], files[j].name);

      this.service.send(this.url, formData).subscribe(
        response => {
          this.loading = false;
          this.onSaving.emit(this.loading);
          this.resetInput();

          if (!response.Commit) {
            this.throwError(response.Message);
            return;
          }

          this.onSuccess.emit(response.DataSource);
        },
        error => {
          this.onSaving.emit(false);
          this.throwError(getErrorMessage(error));
          this.resetInput();
        }
      );
    }
  }

  resetInput() {
    this.showInput = false;

    setTimeout(() => {
      this.showInput = true;
    }, 1000);
  }

  throwError(error: string) {
    this.onError.emit(error);

    if (this.toastr) {
      this.toastr.add({
        severity: "error",
        summary: "Carga de archivos",
        detail: error
      });
    }

    this.loading = false;
  }
}
